module.exports = __webpack_public_path__ + "media/images/logo-7f72a6de7947507a0bf9ca88e5a472ba.png";